import React, {useState} from 'react'
import {FaRegCopy, FaWhatsapp} from 'react-icons/fa'
import Modal from '@components/V3/Modal'
import classnames from '@helpers/misc/classnames'
import copyText from '@helpers/strings/copy'
import useIsMobile from '@hooks/useIsMobile'
import useMessage from '@hooks/useMessage'
import {useTranslation} from 'next-i18next'

export interface Props {
  isOpen: boolean
  onClose: () => void
  messageToShare: string
  title?: React.ReactNode
}

const ShareButton = ({
  className,
  children,
  tooltip,
  onClick
}: {
  className?: string
  children: React.ReactNode
  tooltip?: string
  onClick?: () => void
}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      className={classnames(
        'relative rounded-full flex items-center justify-center p-3 text-lg transition-all duration-200 ease-in-out cursor-pointer',
        className
      )}>
      {children}
      {tooltip && showTooltip ? (
        <div className="font-semibold absolute -bottom-8 bg-gray-800 bg-opacity-80 text-white text-xs px-2 py-1 rounded-md min-w-max">
          {tooltip}
        </div>
      ) : null}
    </div>
  )
}

export default function ShareModal(props: Props) {
  const {t} = useTranslation('generic')
  const isMobile = useIsMobile()
  const showMessage = useMessage()
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      header={<h2 className="">{props.title ? props.title : t('share.title')}</h2>}>
      <div className="flex flex-row gap-4 justify-center py-5">
        <a
          href={
            isMobile
              ? `whatsapp://send?text=${props.messageToShare}`
              : `https://wa.me/?text=${props.messageToShare}`
          }
          target="_blank"
          rel="noopener noreferrer">
          <ShareButton
            className="bg-green-500 hover:bg-green-600 text-white"
            tooltip={t('share.whatsapp')}>
            <FaWhatsapp className="h-7 w-7" />
          </ShareButton>
        </a>
        <ShareButton
          onClick={() => {
            copyText(props.messageToShare)
            showMessage(t('fields.copied'))
          }}
          className="bg-slate-500 hover:bg-slate-600 text-white"
          tooltip={t('share.copy')}>
          <FaRegCopy className="h-7 w-7" />
        </ShareButton>
      </div>
    </Modal>
  )
}
